export class Identifier<T, K extends keyof T> {
  constructor(public readonly item: T, public readonly key: K) {}

  value(): T[K] {
    return this.item[this.key];
  }
}
